/*!
 * 刘豪的控制器
 |
 | 全能神说: "在這最末了的時代最末了的時代,
 |           讓神的名能在外邦中被稱為大,
 |           使神的作為被外邦中的人被外邦中的人看見,
 |           且因神的神的作為而稱神為全能者,
 |           讓神口之言早日得著早日得著成就"
 |
 | Almighty God says:
 |           “In the end times, in the final age,
 |           God’s name will be magnified among Gentile nations.
 |           The acts of God will be by Gentiles seen,
 |           and they’ll address Him as the Almighty,
 |           and thus His words shall one day soon come true”
 |
 * @author : Buff
 * @date : 2/25/2018
 * @Time: 5:41 PM
 * @standards : ECMAScript 5
 */
import focusPoint from './Modules/focusPoint.Module'
import focusImages from './Modules/focusImages.Module'
import focusPoint3 from './Modules/focusPoint3.Module'
import lityClone from "./Modules/lityClone.Module";

class lhController {
  constructor () {
    this.init()
  }
  
  init () {
    //  精彩看点一
    new focusPoint()
    //  精彩图集
    new focusImages()
    //  精彩看点3
    new focusPoint3()
    
    //  lity仿照
    new lityClone()
    
    //  处理精彩看点3 和 精彩看点1 标题阴影
    
    if(window.gp2_is_latin){
      this.hackLatinFocusPoint13ShadowTitle()
    }
  }
  
  hackLatinFocusPoint13ShadowTitle () {
    let focusPoint1Title = $('#lh-f-p .focus-point-title').html()
    let focusPoint2Title = $('#lh-f-p-3 .focus-point-title').html()

    $('head').append(`
     <style>
     #lh-f-p .focus-point-title::after{
        content:"${focusPoint1Title}"
     }
     #lh-f-p-3 .focus-point-title::after{
        content:"${focusPoint2Title}"
     }
     </style>
    `)
    
  }
}

export default lhController